import { useMutation } from '@apollo/client';
import { TTranslator } from '@smartshell/ui-kit';
import { NavigateFunction } from 'react-router-dom';

import { TLocalesKeys } from 'localization';
import {
  CREATE_WORKER,
  ICreateWorkerRequest,
  ICreateWorkerResponse,
} from 'schemas';
import notification from 'services/notificationService';

import { TCreateWorker } from './interfaces';

export const useCreateWorker = (
  t: TTranslator<TLocalesKeys>,
  navigate: NavigateFunction
): TCreateWorker => {
  const [createWorker] = useMutation<
    ICreateWorkerResponse,
    ICreateWorkerRequest
  >(CREATE_WORKER, {
    onCompleted: () => {
      navigate('/workers');
      notification.info({
        t,
        title: t('worker.created'),
        type: 'success',
        dismiss: 5,
      });
    },
  });

  return createWorker;
};
